<template>
  <div>
    <div class="wrapper">
      <div class="trigger" @click="openDropDown()">
        <slot></slot>
      </div>
      <div v-if="droppedDown">
        <div class="background" @click="handleCloseDropdown()"></div>
        <div class="dropdown" @click.stop="swallowClick">
          <div class="content">
            <div v-if="resetPasswordForm">
              <div class="exit-row">
                <span class="logout-button" v-on:click="returnToLoginScreen">
                  <Fai :icon="['fas', 'sign-out']"/>
                  <span style="padding: 0 1em 0 0.5em;">RETURN TO LOGIN</span>
                </span>
              </div>
              <form class="pure-form" @submit.prevent="sendResetPasswordRequest">
                <div class="reset-message-container">
                  <span class="reset-message">{{resetPasswordMessage}}</span>
                </div>
                <fieldset>
                  <div class="row">
                    <input v-model="loginFormModel.email" type="email" placeholder="Email" autofocus>
                  </div>
                </fieldset>
                <div class="reset-message-container" v-if="resetPasswordResponseData">
                  <span v-bind:class="errorMessage" class="reset-message">{{resetPasswordRequestResponseMessage}}</span>
                </div>
                <div class="login-button-row">
                  <button v-if="this.resetPasswordLoadingPristine || this.resetPasswordLoadingFailed"
                          type="submit"
                          class="pure-button bigmi-cyan-blue-2-button bigmi-wide-button bigmi-shadowed-button">
                    <span>{{resetPasswordButtonText}}</span>
                  </button>
                  <div v-else-if="this.resetPasswordLoadingSucceeded"
                          v-on:click="returnToLoginScreen"
                          class="pure-button bigmi-cyan-blue-2-button bigmi-wide-button bigmi-shadowed-button">
                    <span>{{resetPasswordButtonText}}</span>
                  </div>
                  <Loading v-else-if="resetPasswordLoadingStarted"></Loading>
                </div>
              </form>
            </div>
            <div v-else>
              <form class="pure-form" @submit.prevent="handleSubmit">
                <fieldset>
                  <div class="row">
                    <input v-model="loginFormModel.email" type="email" placeholder="Email" autofocus>
                  </div>
                  <div class="row">
                    <input :type="passwordInputType" v-model="loginFormModel.password" placeholder="Password">
                    <Fai v-if="showPassword" class="show-password-icon" v-on:click="setHidePassword" :icon="['far', 'eye']"/>
                    <Fai v-else class="show-password-icon" v-on:click="setShowPassword" :icon="['far', 'eye-slash']"/>
                  </div>
                  <div class="forgot-password-link-container">
                    <span v-on:click="openForgotPasswordForm" class="forgot-password-link">Forgot password?</span>
                  </div>
                </fieldset>
                <div class="error-message-container" v-if="loginLoadingStateFailed">
                  <span class="error-message">{{loginErrorMessage}}</span>
                </div>
                <div class="login-button-row">
                  <button type="submit"
                          class="pure-button bigmi-cyan-blue-2-button bigmi-wide-button bigmi-shadowed-button">
                    <span>{{buttonText}}</span>
                  </button>
                </div>
              </form>
              <div>
                <RouterLink class="signup-link"  :to="signUpRoute">
                  <a v-on:click="closeDropdown" class="font-primary"> Not a member yet? Register</a>
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {loggerMixin} from '../../mixins/logger'
  import {
    LOGIN,
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    SET_SESSION,
    R_NAME_SIGN_UP,
    SET_LOGIN_DROPDOWN_STATE,
    RESET_LOGIN_REDIRECT,
    SET_RESET_PASSWORD_SHOW_STATE, RESET_PASSWORD,
  } from '../../services/constants'

  export default {
    name: 'LoginDropdown',
    mixins: [loggerMixin],
    data() {
      return {
        loginFormModel: null,
        showPassword: false,
      }
    },
    computed: {
      ...mapGetters([]),
      droppedDown() {
        return this.$store.state.userModule.loginDropdownShowState
      },
      sessionFromStore() {
        return this.$store.state.userModule.session
      },
      loginLoadingState() {
        return this.sessionFromStore.loadingState
      },
      resetPasswordLoadingState(){
        return this.$store.state.userModule.resetPasswordState.loadingState
      },
      resetPasswordResponseData(){
        return this.$store.state.userModule.resetPasswordState.data
      },
      buttonText() {
        let s = ''
        switch (this.loginLoadingState) {
          case LOADING_STARTED:
            s = 'SIGNING IN'
            break
          case LOADING_COMPLETED_SUCCESS:
            s = 'SUCCESSFUL'
            break
          case LOADING_COMPLETED_FAILURE:
            s = 'SIGN IN'
            break
          default:
            s = 'SIGN IN'
            break
        }
        return s
      },
      loginLoadingStateFailed(){
        return this.loginLoadingState === LOADING_COMPLETED_FAILURE
      },
      resetPasswordLoadingPristine(){
        return this.resetPasswordLoadingState === LOADING_PRISTINE
      },
      resetPasswordLoadingStarted(){
        return this.resetPasswordLoadingState === LOADING_STARTED
      },
      resetPasswordLoadingSucceeded(){
        return this.resetPasswordLoadingState === LOADING_COMPLETED_SUCCESS
          && this.resetPasswordResponseData.success
      },
      resetPasswordLoadingFailed(){
        return this.resetPasswordLoadingState === LOADING_COMPLETED_FAILURE
          || (this.resetPasswordLoadingState === LOADING_COMPLETED_SUCCESS
                  && !this.resetPasswordResponseData.success)
      },
      resetPasswordButtonText() {
        let s = ''
        if(this.resetPasswordLoadingSucceeded){
          s = 'RETURN TO LOGIN'
        }
        else if (this.resetPasswordLoadingFailed){
          s = 'TRY AGAIN'
        }
        else{
          s = 'SUBMIT'
        }
        return s
      },
      signUpRoute(){
        return {name: R_NAME_SIGN_UP}
      },
      resetPasswordForm(){
        return this.$store.state.userModule.resetPasswordShowState
      },
      resetPasswordMessage(){
        return 'Don\'t worry! If you enter the email address you used to sign up, we\'ll send a link to reset it.  If you don\'t have access to that email, please sign up for a new account.'
      },
      resetPasswordRequestResponseMessage(){
        return this.$store.state.userModule.resetPasswordState.data && this.$store.state.userModule.resetPasswordState.data.message
      },
      loginErrorMessage(){
        return this.sessionFromStore.error
      },
      passwordInputType(){
        return this.showPassword ? "text" : "password"
      },

    },
    methods: {
      openDropDown() {
        this.$store.commit(SET_LOGIN_DROPDOWN_STATE, true)
      },
      closeDropdown(){
        this.$store.commit(SET_LOGIN_DROPDOWN_STATE, false)
      },
      handleCloseDropdown() {
        this.$store.commit(RESET_LOGIN_REDIRECT)
        this.$store.commit(SET_LOGIN_DROPDOWN_STATE, false)
        this.$store.commit(SET_SESSION, {
          loadingState: LOADING_PRISTINE,
          data: this.sessionFromStore.data,
          error: this.sessionFromStore.error,
        })
      },
      swallowClick() {

      },
      handleSubmit() {
        this.$store.dispatch(LOGIN, this.loginFormModel).then(() => {
          if (this.loginLoadingState === LOADING_COMPLETED_SUCCESS) {
            this.$router.push(this.$store.state.userModule.loginRedirect)
            this.handleCloseDropdown()
          }
        })
      },
      sendResetPasswordRequest(){
        this.$store.dispatch(RESET_PASSWORD, this.loginFormModel.email)
      },
      resetLoginFormModel() {
        this.loginFormModel = {
          email: '',
          password: '',
        }
      },
      openForgotPasswordForm(){
        this.$store.commit(SET_RESET_PASSWORD_SHOW_STATE, true)
      },
      returnToLoginScreen(){
        this.$store.commit(SET_RESET_PASSWORD_SHOW_STATE, false)
      },
      errorMessage(){
        return {
          error: !this.resetPasswordResponseData.success,
        }
      },
      setHidePassword(){
        this.showPassword = false
      },
      setShowPassword(){
        this.showPassword = true
      },
    },
    created() {
      this.resetLoginFormModel()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .wrapper {
    position: relative;
  }

  .background {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .dropdown {
    display: inline-block;
    position: absolute;
    right: 0;
    width: 80vw;
    max-width: 380px;
    background-color: $yellow-green-1;
    color: white;
    font-size: 16px;
    font-weight: lighter;
    box-shadow: $cyan-blue-3 0 2px 4px 0;
  }

  .content {
    padding: 1em 0 2em;
  }

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1em 1em;
  }

  .login-button-row {
    display: flex;
    justify-content: center;
    padding: 0 1em;
    font-weight: 400;

  }

  .signup-link{
    padding: 1em 0 0 0;
    display: flex;
    justify-content: center;
    font-weight: 400;
  }

  .pure-form input {
    font-size: 13px;
    @media #{$mobile} {
      font-size: 16px;
    }
    box-shadow: none;
    border-radius: 3px;
    border: solid 1px $cyan-blue-4;
    padding: 10px 0 10px 15px;
    width: 100%;
    color: $cyan-blue-3;
    &:placeholder-shown {
      color: $gray-3;
    }
    &:-ms-input-placeholder {
      color: $gray-3;
    }
  }

  .forgot-password-link-container{
    padding: 0 1em;
    text-align: right;
    .forgot-password-link{
      color: black;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .reset-message-container{
    padding: 0 1em 1em;

    .reset-message{
      color: black;
    }
  }

  .error-message-container{
    padding: 0 1em 1em;
    text-align: left;

    .error-message{
      color: $red-2;
    }
  }

  .exit-row {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 1em;
    color: black;
    .logout-button{
      cursor: pointer;
    }
  }

  .error{
    color: $red-2;
  }

  .show-password-icon{
    margin: 0.25em 0 0.25em 0.5em;
    font-size: medium;
    cursor: pointer;
    color: black;
  }


</style>
